import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createSelector } from 'reselect';
import { get, isEmpty, find, map, remove } from 'lodash';
import { withRouter } from 'react-router-dom';
import { loadTexts } from '../../config/texts';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Card,
  Modal,
  IconButton,
  Paper,
  Typography,
  Grid,
  Input,
  Switch,
  Menu,
  MenuItem,
} from '@material-ui/core';
import {
  CreditCard,
  CloudUpload,
  HighlightOff,
  AttachFile,
} from '@material-ui/icons';

import {
  ApproveTable,
  ConfirmationPopup,
  HeaderTable,
  TabBar,
  PaperHeader,
} from '../../app/components';
import { fetchUser } from '../auth/actions';
import { subscribeToSubsidy, createSubsidy, editSubsidy } from './actions';

import AddCredits from './AddCredits';

import {
  fetchSubsidizedStudents,
  fetchStudentSubsidyTransactions,
  approveStudentSubsidy,
  rejectStudentSubsidy,
  addSubsidyCredits,
  clearPaymentStatus,
  adminAddCard,
  subsidyCreditsPurchase,
  adminChangeDefaultCard,
} from './actions';

import { getMoment } from '../../util/dates';
import Stripe from '../../util/stripe';
import { postImage } from '../../config/images';
const TEXT_KEY = "subsidy";

class Subsidy extends React.Component {
  state = {
    open: false,
    openHistory: false,
    openAddCredits: false,
    showRemoveModal: false,
    showAddCreditsModal: false,
    showAddCardInputs: false,
    cardName: '',
    cardholderName: '',
    mode: null,
    anchorEl: null,
    tabValue: 0,
    selected: { student: '', subsidy: '' },
    selectedForCredits: '',
    selectedForHistory: '',
    openProgramModal: false,
    editMode: false,
    programName: '',
    programDescription: '',
    switchOn: false,
    image: null,
    selectedPrograms: [],
    texts: loadTexts(TEXT_KEY, this.props.locale)
  };

  componentDidMount() {
    this._subscription = subscribeToSubsidy({
      organizationIds: this.props.organizations.map(x => x._id),
    });

    this._subscription.subscribe(() => {
      this.props.fetchUser();
    });
  }

  componentWillUnmount() {
    if (this._subscription) this._subscription.unsubscribe();
  }

  dragOver(e) {
    e.preventDefault();
  }

  dragEnter(e) {
    e.preventDefault();
  }

  dragLeave(e) {
    e.preventDefault();
  }

  fileDrop(e) {
    e.preventDefault();
    const file = e.dataTransfer.files;
    this.setState({ image: file });
  }

  onCheckRow(d) {
    const { selectedPrograms } = this.state;
    const { programs } = this.props;

    const temp = selectedPrograms;
    if (!isEmpty(find(selectedPrograms, i => i._id == d._id))) {
      remove(selectedPrograms, i => i._id == d._id);
    } else {
      const p = find(programs, p => p._id === d._id);
      temp.push(p);
    }
    this.setState({ selectedPrograms: temp });
  }

  onCloseMenu() {
    this.setState({ anchorEl: null });
  }

  renderProgramModalTitle() {
    const { classes } = this.props;
    const { editMode, texts: { title } } = this.state;
    return (
      <Grid item>
        <Typography variant="title">
          {editMode ? title.edit : title.add}
        </Typography>
        <div className={classes.line} />
      </Grid>
    );
  }

  renderProgramModalInputs() {
    const { programName, programDescription, selectedPrograms, texts: { title } } = this.state;
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Grid item className={classes.border}>
          <Input
            placeholder={title.program_name}
            disableUnderline
            fullWidth
            onChange={e => this.setState({ programName: e.target.value })}
            value={programName}
          />
        </Grid>
        <Grid item className={classes.border}>
          <Input
            placeholder={title.program_description}
            disableUnderline
            fullWidth
            multiline
            rows={5}
            rowsMax={5}
            onChange={e =>
              this.setState({ programDescription: e.target.value })
            }
            value={programDescription}
          />
        </Grid>
      </React.Fragment>
    );
  }

  renderDropImage() {
    const { classes } = this.props;
    const { image, selectedPrograms, editMode, texts: { title } } = this.state;
    if (isEmpty(image))
      return (
        <Grid
          container
          className={classes.dashedBorder}
          onDragOver={e => this.dragOver(e)}
          onDragEnter={e => this.dragEnter(e)}
          onDragLeave={e => this.dragLeave(e)}
          onDrop={e => this.fileDrop(e)}
        >
          <CloudUpload color="disabled" style={{ fontSize: 60 }} />
          <Typography color="textSecondary">
            {title.drag_image}
          </Typography>
        </Grid>
      );
    return (
      <div className={classes.fileContainer}>
        <AttachFile color="inherit" style={{ color: 'lightgrey' }} />
        <Typography>
          {typeof image !== 'object' ? 'Image' : image[0].name}
        </Typography>
        <IconButton onClick={() => this.setState({ image: null })}>
          <HighlightOff color="inherit" style={{ color: 'lightgrey' }} />
        </IconButton>
      </div>
    );
  }

  renderCardInputs() {
    const { cardName, cardNumber, cardholderName, texts: { card } } = this.state;
    return (
      <div>
        <Input
          placeholder={card.name}
          disableUnderline
          fullWidth
          onChange={e => this.setState({ cardName: e.target.value })}
          value={cardName}
        />
        <Input
          placeholder={card.holder}
          disableUnderline
          fullWidth
          onChange={e => this.setState({ cardholderName: e.target.value })}
          value={cardholderName}
        />
        <Input
          placeholder={card.number}
          disableUnderline
          fullWidth
          onChange={e => this.setState({ cardNumber: e.target.value })}
          value={cardNumber}
        />
      </div>
    );
  }

  renderAddCreditsModal() {
    const {
      classes,
      selectedOrganization,
      organizations,
      paymentStatus,
      cards,
    } = this.props;
    const { showAddCreditsModal, selectedForCredits } = this.state;
    const name = `${get(selectedForCredits, 'user.first')} ${get(
      selectedForCredits,
      'user.last',
    )}`;

    const org = organizations.find(o => o._id === selectedOrganization);

    const props = {
      _id: get(selectedForCredits, '_id'),
      cards,
      currency: get(org, 'currency') || 'cad',
      subsidies: (get(selectedForCredits, 'subsidies') || []).map(
        x => x.subsidy,
      ),
      onAddCard: async token => {
        await this.props.adminAddCard({
          organization: selectedOrganization,
          token,
        });
        this.props.fetchUser();
        this.setState({ showAddCreditsModal: false });
      },
      onChangeDefaultCard: async cardId => {
        await this.props.adminChangeDefaultCard({ card: cardId });
        this.props.fetchUser();
      },
      onPurchase: async amount => {
        await this.props.subsidyCreditsPurchase({
          organization: selectedOrganization,
          amount: amount * 100,
        });
        await this.props.fetchUser();
        this.setState({ showAddCreditsModal: false });
      },
      onSubmit: async ({ token, amount, currency, subsidy }) => {
        if (!token) return Promise.reject();
        // submit and close
        // convert amount to cents
        const amountInCents = Math.round(amount * 100);

        return this.props.addSubsidyCredits({
          student: get(selectedForCredits, '_id'),
          subsidy,
          currency,
          token,
          amount: amountInCents,
        });
      },
      paymentStatus,
      clearPaymentStatus: this.props.clearPaymentStatus,
    };
    return (
      <Modal
        open={showAddCreditsModal}
        onClose={() => this.setState({ showAddCreditsModal: false })}
      >
        <Card className={classes.historyModal}>
          <Typography variant="subheading" gutterBottom>
            {this.state.texts.button_text.add_credits}
          </Typography>
          <div>{Stripe.load(AddCredits, props)}</div>
        </Card>
      </Modal>
    );
  }

  renderRemoveModal() {
    const { showRemoveModal, texts: { title } } = this.state;
    const { classes } = this.props;

    return (
      <Modal
        open={showRemoveModal}
        onClose={() => this.setState({ showRemoveModal: false })}
      >
        <Card className={classes.programModalContainer}>
          <Grid
            container
            direction="column"
            justify="space-between"
            alignItems="center"
          >
            <Typography>
              {title.remove_program}
            </Typography>
          </Grid>
        </Card>
      </Modal>
    );
  }

  renderSwitch() {
    const { switchOn, texts: { button_text } } = this.state;
    const { classes } = this.props;

    return (
      <Grid container style={{ alignItems: 'center' }}>
        <Typography variant="body2">{button_text.auto_approve}</Typography>
        <Switch
          checked={switchOn}
          onChange={() => this.setState({ switchOn: !switchOn })}
          value="checkedB"
          color="primary"
        />
      </Grid>
    );
  }

  renderProgramModalButtons() {
    const {
      programName,
      switchOn,
      programDescription,
      editMode,
      selectedPrograms,
      texts: { button_text }
    } = this.state;
    const { selectedOrganization } = this.props;

    return (
      <Grid container style={{ justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          style={{ marginRight: 15 }}
          onClick={() =>
            this.setState({
              openProgramModal: false,
              editMode: false,
              programName: '',
              programDescription: '',
              image: null,
              switchOn: false,
            })
          }
        >
          {button_text.cancel}
        </Button>
        <Button
          variant="contained"
          disabled={isEmpty(programName) || isEmpty(programDescription)}
          onClick={async () => {
            if (
              typeof this.state.image === 'object' &&
              !isEmpty(this.state.image)
            ) {
              const image = this.state.image[0];
              const formdata = new FormData();
              await formdata.append('picture', image);

              const url = `/images/subsidy?name=${programName}&_organization=${selectedOrganization}`;
              postImage(url, formdata).then(async res => {
                if (!editMode)
                  await this.props.createSubsidy({
                    organization: selectedOrganization,
                    name: programName,
                    description: programDescription,
                    autoApprove: switchOn,
                    image: res.data.uri,
                  });
                else
                  await this.props.editSubsidy({
                    organization: selectedOrganization,
                    subsidy: selectedPrograms[0]._id,
                    name: programName,
                    description: programDescription,
                    autoApprove: switchOn,
                    image: res.data.uri,
                  });
                await this.props.fetchUser();
              });
            } else {
              if (!editMode)
                await this.props.createSubsidy({
                  organization: selectedOrganization,
                  name: programName,
                  description: programDescription,
                  autoApprove: switchOn,
                });
              else
                await this.props.editSubsidy({
                  organization: selectedOrganization,
                  subsidy: selectedPrograms[0]._id,
                  name: programName,
                  description: programDescription,
                  autoApprove: switchOn,
                });
              await this.props.fetchUser();
            }
            this.setState({
              openProgramModal: false,
              editMode: false,
              programName: '',
              programDescription: '',
              image: null,
              switchOn: false,
            });
          }}
        >
          {editMode ? button_text.done : button_text.create}
        </Button>
      </Grid>
    );
  }

  renderAddProgramModal() {
    const { openProgramModal } = this.state;
    const { classes } = this.props;

    return (
      <Modal
        open={openProgramModal}
        onClose={() =>
          this.setState({
            openProgramModal: false,
            editMode: false,
            programName: '',
            programDescription: '',
            image: null,
            switchOn: false,
          })
        }
      >
        <Card className={classes.programModalContainer}>
          <Grid container direction="column" justify="space-between">
            {this.renderProgramModalTitle()}
            {this.renderProgramModalInputs()}
            {this.renderDropImage()}
            {this.renderSwitch()}
            {this.renderProgramModalButtons()}
          </Grid>
        </Card>
      </Modal>
    );
  }

  renderProgramButtons() {
    const { classes } = this.props;
    const { anchorEl, selectedPrograms, texts: { button_text } } = this.state;

    return (
      <Grid item>
        <Grid container className={classes.gridContainer}>
          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => this.setState({ openProgramModal: true })}
            >
              {`+ ${button_text.create_program}`}
            </Button>
          </Grid>
          <Grid item className={classes.marginHorizontal}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => this.setState({ showAddCreditsModal: true })}
            >
              {button_text.get_credits}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={e => this.setState({ anchorEl: e.currentTarget })}
            >
              {button_text.action}
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => this.onCloseMenu()}
            >
              <MenuItem
                disabled={selectedPrograms.length !== 1}
                onClick={async () => {
                  await this.setState({
                    openProgramModal: true,
                    editMode: true,
                    image: selectedPrograms[0].image,
                    programName: selectedPrograms[0]['Program Name'],
                    programDescription: selectedPrograms[0].description,
                    switchOn: selectedPrograms[0].autoApprove,
                  });
                  this.onCloseMenu();
                }}
              >
                {button_text.edit}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  this.onCloseMenu();
                  this.setState({ showRemoveModal: true });
                }}
              >
                {button_text.remove}
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  renderProgramCredits(org) {
    const { classes } = this.props;
    const { texts: { title } } = this.state;
    return (
      <Grid item>
        <Grid container className={classes.gridContainer}>
          <Grid item>
            <Typography
              variant="subheading"
              color="inherit"
              className={classes.padding}
            >
              {`${title.current_credits}:`}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="subheading" className={classes.green}>
              {(org.credits / 100).toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.gridContainer}>
          <Typography variant="subheading" className={classes.padding}>
            {`${title.credits_distributed}:`}
          </Typography>
          <Typography variant="subheading">
            {(org.creditsDistributed / 100).toFixed(2)}
          </Typography>
        </Grid>
        <Grid container className={classes.gridContainer}>
          <Typography variant="subheading" className={classes.padding}>
            {`${title.credits_used}`}
          </Typography>
          <Typography variant="subheading" style={{ color: 'red' }}>
            {(org.creditsUsed / 100).toFixed(2)}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  render() {
    const { tabValue, selectedPrograms, texts: { title, header } } = this.state;
    const { organizations, selectedOrganization, programs } = this.props;
    const org = find(organizations, o => o._id === selectedOrganization);
    const filteredPrograms = map(programs, p => ({
      _id: p._id,
      [title.program_name]: p['Program Name'],
      [title.applicants]: p['Applicants'],
      [title.approved_students]: p['Approved Students'],
      [title.credits_distributed]: p['Credits'],
      [title.credits_used]: p['Credits Used'],
    }));

    return (
      <Paper>
        <PaperHeader text={header.program_management} />
        <Grid container justify="space-between" alignItems="flex-end">
          {this.renderProgramCredits(org)}
          {this.renderProgramButtons()}
        </Grid>
        <HeaderTable
          label="program management"
          data={filteredPrograms}
          count={filteredPrograms.length}
          // loading={loading}
          hover={false}
          onRowClick={p =>
            this.props.history.push('/home/subsidy/program', {
              program: find(org.subsidies, s => s._id === p._id),
              organization: org,
            })
          }
          showCheckbox
          onCheckRow={d => this.onCheckRow(d)}
          onCheckAll={array =>
            this.setState({ selectedPrograms: array.slice() })
          }
        />
        {this.renderAddProgramModal()}
        {this.renderRemoveModal()}
        {this.renderAddCreditsModal()}
      </Paper>
    );
  }
}

const styles = theme => ({
  green: {
    color: '#17C289',
  },
  addCardContainer: {
    backgroundColor: 'lightgrey',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 5,
    justifyContent: 'flex-start',
    width: '100%',
    marginBottom: 50,
    borderRadius: 4,
  },
  fileContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: 5,
    marginBottom: 5,
  },
  line: {
    width: '100%',
    backgroundColor: 'grey',
    height: 1,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  border: {
    border: '30px solid grey',
    borderRadius: 4,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  dashedBorder: {
    border: '30px dashed grey',
    borderRadius: 4,
    borderWidth: 1,
    alignItems: 'center',
    padding: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    justifyContent: 'center',
    width: '100%',
    height: 200,
    flexDirection: 'column',
  },
  marginHorizontal: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  gridContainer: {
    paddingLeft: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 3,
  },
  padding: {
    paddingRight: theme.spacing.unit,
  },
  programModalContainer: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: theme.spacing.unit * 75,
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    padding: theme.spacing.unit * 3,
  },
  historyModal: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: theme.spacing.unit * 75,
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    padding: theme.spacing.unit * 3,
  },
  transactionContainer: {
    width: '100%',
    maxHeight: theme.spacing.unit * 50,
    overflow: 'auto',
  },
});

export default compose(
  withStyles(styles, { name: 'Subsidy' }),
  connect(
    state => ({
      locale: state.appState.locale,
      selectedOrganization: get(state, 'auth.selectedOrganization'),
      cards: get(state, 'auth.data.user.stripe'),
      organizations: get(state, 'auth.data.user.organizations'),
      paymentStatus: get(state, 'subsidy.paymentStatus.data') || '',
      transactionData: createSelector(
        state => get(state, 'subsidy.transactions.data.list') || [],
        list =>
          list.map(l => ({
            _id: l._id,
            amount: (l.amount / 100).toFixed(2),
            subsidy: l.subsidy.name,
            date: getMoment(l.createdAt.timestamp).format('MMM D, Y'),
          })),
      )(state),
      programs: createSelector(
        state => get(state, 'auth.selectedOrganization'),
        state => get(state, 'auth.data.user.organizations'),
        (selectedOrg, org) => {
          const o = find(org, o => o._id === selectedOrg);
          const programs = map(o.subsidies, s => ({
            _id: s._id,
            'Program Name': s.name,
            Applicants: s.requestedCount,
            'Approved Students': s.approvalCount,
            Credits: (s.creditsDistributed / 100).toFixed(2),
            'Credits Used': (s.creditsUsed / 100).toFixed(2),
            description: s.description,
            autoApprove: s.autoApprove,
            image: s.image,
          }));
          return programs;
        },
      )(state),
      data: createSelector(
        state => get(state, 'subsidy.list.data.order') || [],
        list => {
          const data = { requested: [], approved: [] };
          // for requested, bring the requested one to the top
          // list is a list of students

          const getName = student =>
            `${get(student, 'user.first') || ''} ${get(student, 'user.last') ||
              ''}`;
          data.requested = list.reduce((acc, student) => {
            // if we can't find a requested subsidy, skip
            let subsidy = (student.subsidies || []).find(
              s => s.status === 'requested',
            );
            if (!subsidy) return acc;

            // get the most recently requested subsidy
            let mostRecent = getMoment(subsidy.requestedAt.timestamp);
            student.subsidies.forEach(s => {
              if (s.status !== 'requested') return;
              const date = getMoment(s.requestedAt.timestamp);
              if (date.isAfter(mostRecent)) {
                mostRecent = date;
                subsidy = s;
              }
            });

            return [
              ...acc,
              {
                fields: {
                  _id: `${student._id}_${get(subsidy, 'subsidy._id')}`,
                  name: getName(student),
                  subsidy: get(subsidy, 'subsidy.name'),
                  'requested at': mostRecent.format('MMM D, Y'),
                  _data: student,
                },
                status: subsidy.status.toUpperCase(),
                user: student.user,
              },
            ];
          }, []);

          data.approved = list.reduce((acc, student) => {
            // get list of approved subsidies
            let subsidies = (student.subsidies || []).reduce((acc, s) => {
              if (s.status !== 'approved') return acc;
              return `${s.subsidy.name}, ${acc}`;
            }, '');

            // if no approved found, skip
            if (!subsidies) return acc;

            // get approved subsidies
            const subsidiesList = (student.subsidies || []).reduce;
            // just a normal table

            // Get last paid subsidy
            let lastPaid = get(student, 'lastSubsidyTransaction');
            if (!lastPaid) {
              lastPaid = 'N/A';
            } else {
              lastPaid = getMoment(lastPaid.createdAt.timestamp);
              lastPaid = lastPaid.format('MMM D, Y');
            }

            return [
              ...acc,
              {
                _id: student._id,
                name: getName(student),
                subsidies: subsidies.substring(0, subsidies.length - 2),
                'Last paid': lastPaid,
                _data: student,
              },
            ];
          }, []);

          return data;
        },
      )(state),
    }),
    dispatch => ({
      fetchSubsidizedStudents: params =>
        dispatch(fetchSubsidizedStudents(params)()),
      fetchStudentSubsidyTransactions: params =>
        dispatch(fetchStudentSubsidyTransactions(params)()),
      approveStudentSubsidy: params =>
        dispatch(approveStudentSubsidy(params)()),
      rejectStudentSubsidy: params => dispatch(rejectStudentSubsidy(params)()),
      addSubsidyCredits: params => dispatch(addSubsidyCredits(params)()),
      clearPaymentStatus: () => dispatch(clearPaymentStatus()),
      fetchUser: () => dispatch(fetchUser()()),
      createSubsidy: params => dispatch(createSubsidy(params)()),
      editSubsidy: params => dispatch(editSubsidy(params)()),
      adminAddCard: params => dispatch(adminAddCard(params)()),
      subsidyCreditsPurchase: params =>
        dispatch(subsidyCreditsPurchase(params)()),
      adminChangeDefaultCard: params =>
        dispatch(adminChangeDefaultCard(params)()),
    }),
  ),
)(Subsidy);



// WEBPACK FOOTER //
// ./src/modules/subsidy/Scene.js